import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-4/12 shadow-lg rounded-sm absolute top-44 right-1/4 p-6"
};
const _hoisted_3 = {
  key: 0,
  class: "p-2 text-sm text-center text-gray-800"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 2,
  class: ""
};
const _hoisted_6 = {
  class: "row-fluid py-2"
};
const _hoisted_7 = {
  key: 0,
  class: "w-20 h-20 rounded-full flex justify-center items-center bg-gray-500 cursor-pointer"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "px-2 py-4 flex justify-end"
};
import { reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useInvoiceEmailStore } from './useInvoiceEmailStore.js';
import imageUtilities from '@/services/imageUtilities.js';
import fileUtilities from '@/services/fileUtilities';
export default {
  __name: 'UpdateLogoModal',
  props: {
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const invoiceEmailStore = useInvoiceEmailStore();
    const props = __props;
    const state = reactive({
      resizedImage: '',
      fileName: ''
    });
    function close() {
      state.resizedImage = '';
      invoiceEmailStore.toggleUpdateLogoModal();
    }
    function getFile() {
      const fileUpload = document.getElementById('fileInput');
      if (fileUpload != null) {
        fileUpload.click();
      }
    }
    function getPic(pic) {
      if (state.resizedImage.length > 0) {
        return state.resizedImage;
      }
      return pic;
    }
    function resizeLogo(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      state.fileName = files[0].name;
      createImage(files[0]);
    }
    async function createImage(file) {
      state.resizedImage = await imageUtilities.createPreviewImage(file, 500, 374);
    }
    function uploadLogo() {
      const blobData = fileUtilities.createBlobData(state.resizedImage, 'image/png');
      const data = new FormData();
      if (state.resizedImage) {
        data.append('logo', blobData, state.fileName);
        invoiceEmailStore.sentImage(data, state.resizedImage);
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: ""
      }, [_createElementVNode("h3", {
        class: "text-center"
      }, "Update Logo")], -1)), !_unref(invoiceEmailStore).uploadingImage ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Select a file from your computer to upload as the logo presented in your email and invoice PDF. Images will be automatically resized to fit a max width of 500px or a max height of 374px. For best results, use an image with a 4:3 aspect ratio (a wide rectangle) ")) : _createCommentVNode("", true), !_unref(invoiceEmailStore).uploadingImage && (_unref(invoiceEmailStore).invoiceDelivery.logoUrl || state.resizedImage) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "p-2 flex justify-center bg-white",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => getFile(), ["prevent"]))
      }, [!_unref(invoiceEmailStore).uploadingImage ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: getPic(`${props.leanLawAuth.domain}/v1/invoicedeliverysettings/logo`)
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "self-end -ml-3 -mt-3"
      }, [_createElementVNode("div", {
        class: "w-6 h-6 rounded-full flex justify-center items-center bg-primary cursor-pointer"
      }, [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("span", {
        class: "fa fa-pencil text-[10px]"
      })])])], -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "flex justify-center p-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => getFile(), ["prevent"]))
      }, [!state.resizedImage && !_unref(invoiceEmailStore).invoiceDelivery.logoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, "LOGO", -1)]))])) : _createCommentVNode("", true), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "self-end -ml-5 -mt-3"
      }, [_createElementVNode("div", {
        class: "w-6 h-6 rounded-full flex justify-center items-center bg-primary cursor-pointer"
      }, [_createElementVNode("span", {
        class: "text-gray-100 text-xs"
      }, [_createElementVNode("span", {
        class: "fa fa-pencil text-[10px]"
      })])])], -1)), _createElementVNode("div", null, [_unref(invoiceEmailStore).uploadingImage ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[7] || (_cache[7] = [_createElementVNode("i", {
        class: "fa fa-spinner fa-spin fa-5x"
      }, null, -1)]))])) : _createCommentVNode("", true)])])])])), _createElementVNode("input", {
        type: "file",
        class: "hidden",
        id: "fileInput",
        onChange: _cache[2] || (_cache[2] = _withModifiers($event => resizeLogo($event), ["prevent"]))
      }, null, 32), _createElementVNode("div", _hoisted_9, [_createVNode(LlSecondaryButton, {
        class: "px-12 mr-4",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => close(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        class: "px-12",
        disabled: state.resizedImage.length === 0,
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => uploadLogo(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Save Changes ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])])]);
    };
  }
};